import { createSelector } from 'reselect';

export const getInvoices = createSelector(
  (state) => state.invoices.data.invoices,
  (invoices) => {
    return invoices;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.invoices.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getCustomEmail = createSelector(
  (state) => state.invoices.ui.customEmail,
  (customEmail) => {
    return customEmail;
  }
);

export const getCustomEmailValid = createSelector(
  (state) => state.invoices.ui.customEmailValid,
  (customEmailValid) => {
    return customEmailValid;
  }
);

export const getCurrentInvoice = createSelector(
  (state) => state.invoices.data.currentInvoice,
  (currentInvoice) => {
    return currentInvoice;
  }
);

export const getEdit = createSelector(
  (state) => state.invoices.ui.edit,
  (edit) => {
    return edit;
  }
);

export const getForm = createSelector(
  (state) => state.invoices.ui.form,
  (form) => {
    return form;
  }
);

export const getInvalidFields = createSelector(
  (state) => state.invoices.ui.invalidFields,
  (invalidFields) => {
    return invalidFields;
  }
);

export const getPdf = createSelector(
  (state) => state.invoices.ui.pdf,
  (pdf) => {
    return pdf;
  }
);

export const getShowEmailModal = createSelector(
  (state) => state.invoices.ui.showEmailModal,
  (showEmailModal) => {
    return showEmailModal;
  }
);

export const getShowPdfViewer = createSelector(
  (state) => state.invoices.ui.showPdfViewer,
  (showPdfViewer) => {
    return showPdfViewer;
  }
);

export const getShowSave = createSelector(
  (state) => state.invoices.ui.showSave,
  (showSave) => {
    return showSave;
  }
);

export const getUsersByClientId = createSelector(
  (state) => state.invoices.data.usersByClientId,
  (usersByClientId) => {
    return usersByClientId;
  }
);

export const getUsersIdSelected = createSelector(
  (state) => state.invoices.ui.usersIdSelected,
  (usersIdSelected) => {
    return usersIdSelected;
  }
);

export const getValidationMessage = createSelector(
  (state) => state.invoices.ui.validationMessage,
  (validationMessage) => {
    return validationMessage;
  }
);

export const getTabSelection = createSelector(
  (state) => state.invoices.ui.tabSelection,
  (tabSelection) => {
    return tabSelection;
  }
);

export const getSelectedStatus = createSelector(
  (state) => state.invoices.ui.selectedStatus,
  (selectedStatus) => {
    return selectedStatus;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/invoices/invoices.js